const judgeMe = () => {
  const writeBtn = document.querySelector('.jdgm-write-rev-link') ?? false;

  if (!writeBtn) return;

  writeBtn.addEventListener('click', () => {
    const productNav = document.querySelector('[data-product-navigation]');
    setTimeout(() => {
      productNav.dataset.state = 'hidden';
    }, 1200);
  });
};

export default judgeMe;
